import { css } from '@emotion/react'

import { colors } from '../../../../styles/theme'

export default css`
  background: ${colors.blueDark};

  .cr-logo-svg {
    fill: ${colors.silverDark};

    @media (hover: hover) {
      &:hover {
        fill: ${colors.silverDark};
      }
    }
  }

  .to-top {
    color: ${colors.silver};

    .icon-chevron {
      stroke: ${colors.silver};
    }

    @media (hover: hover) {
      &:hover {
        color: ${colors.scarpaFlowBright};

        .icon-chevron {
          stroke: ${colors.scarpaFlowBright};
        }
      }
    }
  }

  .social-link {
    background-color: ${colors.silverDark};

    .social-icon {
      fill: ${colors.blueDark};

      .vk {
        &-bg {
          fill: ${colors.white};
        }

        &-logo {
          fill: ${colors.blueDark};
        }
      }
    }

    [lang='ru'] & {
      background-color: ${colors.white};
    }

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.silverChalice};

        .vk-bg {
          fill: ${colors.silverChalice};
        }
      }
    }
  }

  .legal-item > span {
    color: ${colors.silver};
  }

  .legal-link,
  .legal-dns span {
    color: ${colors.silver};

    @media (hover: hover) {
      &:hover {
        color: ${colors.scarpaFlowBright};
      }
    }
  }

  .language {
    &-toggle {
      color: ${colors.silverDark};
      background-color: ${colors.blueBase};
    }

    &-current {
      .triangle-svg {
        fill: ${colors.silverDark};
      }

      @media (hover: hover) {
        &:hover {
          background-color: ${colors.blueLighter};
        }
      }
    }

    &-list {
      background-color: ${colors.blueBase};
      border-bottom: 0.0625rem solid ${colors.silverChalice};
    }

    &-item {
      @media (hover: hover) {
        &:hover {
          color: ${colors.scarpaFlowBright};
        }
      }
    }
  }

  .byline {
    color: ${colors.scarpaFlowLight};
  }
`
